import $ from 'jquery'
import 'stupid-table-plugin'

export function initialise() {
  $('[data-table-sortable]').stupidtable()
}
